import { User } from './auth-user';
import { RootState } from '../../store/root-state';

export const getUserState = (state: RootState): User => state.user.user;

export const getOriginalUser = (state: RootState) => state.user.originalUser;
